<div
    [ngClass]="[
        overlay ? 'loading-overlay-container' : 'loading-container',
        globalLoader ? 'global-loading-container' : 'loading-container',
    ]"
    id="loading-container">
    @if (globalLoader) {
        <img
            [ngSrc]="'assets/images/app-loader.gif'"
            width="150"
            height="150"
            priority
            [alt]="'img.alt.mouseSpinner' | translate"
            id="app-loader-image" />
        <p id="app-loader-text">{{ 'loaderText' | translate }}</p>
    } @else {
        <div class="dot-flashing"></div>
    }

    @if (customText) {
        <p id="loader-custom-text">{{ customText }}</p>
    }
</div>
